module.exports = __webpack_public_path__ + "img/navbar-1.35ee4807.svg";